export default __webpack_public_path__ + "static/media/resources-disabled.67696336.svg";